<script setup lang="ts">
import * as yup from 'yup'
import SmallModel from '@/components/Interface/Modal/ModelSizes/SmallModel.vue'
import { computed, reactive } from 'vue'
import { useGameStore } from '@/stores/gameStore.ts'
import Backend from '@/models/backend.ts'
import FormProcess from '@/models/formProcess.ts'
import FormInput from '@/components/Interface/Modal/Forms/FormInput.vue'
import FormGenericError from '@/components/Interface/Modal/Forms/FormGenericError.vue'
import { useFleetStore } from '@/stores/fleetStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'

// Get the planet data
const gameStore = useGameStore()
const fleetStore = useFleetStore()
const fleetData = computed(() => fleetStore.findFleetById(gameStore.modalData.fleetId))

const backend = new Backend()
const formProcess = new FormProcess()

// Define the validation schema
const schema = yup.object().shape({
  fleetName: yup
    .string()
    .min(3, () => `Use at least 3 characters`)
    .max(32, () => `Do not use more than 32 characters`)
    .matches(/[a-zA-Z]/, () => `Must contain at least one letter`)
    .required(() => `This is required`)
})

// Default form values
const formValues = reactive<{ [key: string]: string }>({
  fleetName: fleetData.value?.name || ''
})

// Form errors
const formErrors = reactive<{ [key: string]: string }>({
  generic: '',
  fleetName: ''
})

// Handle form submission
const submit = () => {
  schema
    .validate(formValues)
    .then(() => {
      formProcess.resetFormErrors(formErrors)
      backend
        .updateFleetName(gameStore.modalData.fleetId, formValues.fleetName)
        .then(() => formProcess.processBackendSuccessResponse())
        .catch((error) => formProcess.processBackendErrorResponse(error, formErrors))
    })
    .catch((error) => formProcess.processFrontendErrorResponse(error, formErrors))
}
</script>

<template>
  <SmallModel title="Edit">
    <form method="post" @submit.prevent="submit" class="pl-4 pr-4 pt-4">
      <FormInput
        label="Fleet name"
        v-model="formValues.fleetName"
        :error="formErrors.fleetName"
        :autoFocus="true"
      />
      <div class="flex justify-between py-2">
        <FormGenericError :error="formErrors.generic" />
        <ActionButton type="submit" class="hidden md:block">Edit</ActionButton>
      </div>
    </form>
  </SmallModel>
</template>

<style scoped lang="scss"></style>
